<template lang="pug">
    article.selector
        .selector__wrp(ref="scroll")
            .selector__wrp-scroll
                .selector__decor-clouds
                template(v-if="pageId === 'basanov'")
                    .slide__decor-basanov-clouds

                .selector__icon
                    img(src="@/assets/img/18_icon_white.svg" alt="Иконка 18+")
                Strap.strap_bright.selector__strap(:text="title")
                .swiper-container(ref="swiper")
                    .swiper-pagination

                    .swiper-nav
                        .swiper-nav__prev(@click="swiperInstance.activeIndex > 0 ? swiperInstance.slidePrev() : swiperInstance.slideTo(slides.length - 1)")
                        .swiper-nav__next(@click="swiperInstance.activeIndex < slides.length - 1 ? swiperInstance.slideNext() : swiperInstance.slideTo(0)")

                    .swiper-wrapper
                        .swiper-slide.slide(
                            v-for="slide, index in slides",
                            :key="slide.id",
                            :data-hash="slide.id"
                            :ref="`${slide.id}Slide`"
                            @mousemove="parallax($event, slide.id)"
                        )
                            template(v-if="slide.id === 'plotkin'")
                                .slide__decor-plotkin-plane
                                    .slide__decor-plotkin-plane-trajectory
                                    .slide__decor-plotkin-plane-img
                                        img(src="@/assets/img/articles/plotkin/selector/selector-plotkin-plane.png" aria-hidden="true")
                                .slide__decor-plotkin-aim-wrp
                                    .slide__decor-plotkin-aim
                            template(v-if="slide.id === 'sultan'")
                                .slide__decor-sultan-plane-path
                                    .slide__decor-sultan-aim.slide__decor-sultan-aim_path-1
                                    .slide__decor-sultan-aim.slide__decor-sultan-aim_path-2
                                    img.slide__decor-sultan-path(src="@/assets/img/articles/sultan/selector/sultan-selector-path.png")
                                    .slide__decor-sultan-plane.js-sultan-plane
                                        img(src="@/assets/img/articles/sultan/selector/sultan-selector-plane.png")
                                .slide__decor-sultan-plane-navigation
                                    .slide__decor-sultan-aim.slide__decor-sultan-aim_navigation-1
                                    .slide__decor-sultan-aim.slide__decor-sultan-aim_navigation-2
                                    img.slide__decor-sultan-navigation(src="@/assets/img/articles/sultan/selector/sultan-selector-navigation.png")
                                    .slide__decor-sultan-plane-nav.js-sultan-plane
                                        img(src="@/assets/img/articles/sultan/selector/sultan-selector-plane-2.png")
                                .slide__decor-sultan-circles
                                    img(src="@/assets/img/articles/sultan/selector/sultan-selector-circles.png")
                                    .slide__decor-sultan-circles-plane.slide__decor-sultan-circles-plane_small
                                    .slide__decor-sultan-circles-plane.slide__decor-sultan-circles-plane_big

                            template(v-if="slide.id === 'german'")
                                .slide__decor-german-trajectory
                                    picture
                                        source(
                                            srcset="@/assets/img/articles/german/selector/german-selector-trajectory-mobile.png"
                                            media="(max-width: 768px)"
                                        )
                                        img(src="@/assets/img/articles/german/selector/german-selector-trajectory.png")
                                    .slide__decor-german-mine.slide__decor-german-mine_1
                                    .slide__decor-german-mine.slide__decor-german-mine_2
                                    .slide__decor-german-mine.slide__decor-german-mine_3

                                .slide__decor-german-binokolus-wrp
                                    .slide__decor-german-binokolus-scale
                                    .slide__decor-german-binokolus
                                        img(src="@/assets/img/articles/german/selector/german-selector-binokolus.png")
                            template(v-if="slide.id === 'dachiev'")
                                .slide__decor-dachiev-water
                                .slide__decor-dachiev-water-boat
                                .slide__decor-dachiev-water-circle


                            template(v-if="slide.id === 'basanov'")
                                .slide__decor-basanov-clouds
                                .slide__decor-basanov-road
                                .slide__decor-basanov-cossacks

                                .slide__decor-basanov-trajectory
                                .slide__decor-basanov-tank.slide__decor-basanov-tank_1
                                .slide__decor-basanov-tank.slide__decor-basanov-tank_2
                                .slide__decor-basanov-tank.slide__decor-basanov-tank_3

                                .slide__decor-basanov-arrows

                            template(v-if="slide.id === 'ohlopkov'")
                                .slide__decor-ohlopkov-aim
                                .slide__decor-ohlopkov-aim-dark
                                .slide__decor-ohlopkov-bullets
                                .slide__decor-ohlopkov-gun
                                .slide__decor-ohlopkov-bg.slide__decor-ohlopkov-forest
                                .slide__decor-ohlopkov-bg.slide__decor-ohlopkov-cloud

                            template(v-if="slide.id === 'domogakov'")
                                .slide__decor-domogakov-mine.slide__decor-domogakov-mine-1
                                .slide__decor-domogakov-mine.slide__decor-domogakov-mine-2
                                .slide__decor-domogakov-map
                                .slide__decor-domogakov-ruler
                                .slide__decor-domogakov-binoculars
                                .slide__decor-domogakov-clouds-2

                                .slide__decor-domogakov-bg.slide__decor-domogakov-forest
                                .slide__decor-domogakov-bg.slide__decor-domogakov-clouds

                            template(v-if="!slide.available.status")
                                .slide__decor-star
                                    img.slide__decor-star-img(src="@/assets/img/selector-star.svg")
                                    .slide__decor-man(:class="`slide__decor-man_${slide.id}`")
                                        img(:src="require(`@/assets/img/selector-stub-${slide.id}.svg`)")





                            .legend-header.slide__portrait(v-if="slide.available.status" :class="`legend-header_${slide.id}`" ref="portrait")
                                img.legend-header__img(:src="require(`@/assets/img/portraits/${slide.id}.png`)" :class="`legend-header__img_${slide.id}`" :alt="slide.name")
                            template(v-if="slide.id === 'dachiev'")
                                .slide__decor-dachiev-cavalry
                                .slide__decor-dachiev-cavalry-arrows
                                .slide__decor-dachiev-cavalry-cross

                            .slide__btns-wrp
                                .slide__lock(v-if='!slide.available.status')
                                    svg(xmlns='http://www.w3.org/2000/svg', viewBox='0 0 142.62 202.88')
                                        path(d='M132.07 82.66V59.9A59.9 59.9 0 0072.18 0h-1.74a59.9 59.9 0 00-59.9 59.9v22.76A17.1 17.1 0 000 98.46v87.31a17.11 17.11 0 0017.11 17.11H125.5a17.12 17.12 0 0017.12-17.11V98.46a17.11 17.11 0 00-10.55-15.8zM81.23 143v17.24a9.92 9.92 0 01-19.84 0V143a16.12 16.12 0 1119.84 0zM30.51 81.35V59.9A40 40 0 0170.44 20h1.74a40 40 0 0139.93 39.9v21.45z', fill='#b3081a')

                                .slide__lead(v-html="slide.lead")
                                .slide__btns
                                    button.slide__arrow.slide__arrow_prev(@click="index > 0 ? swiperInstance.slidePrev() : swiperInstance.slideTo(slides.length - 1)")
                                        span(v-html="index > 0 ? slides[index-1].name : slides[slides.length-1].name")
                                    router-link.slide__link(:class="{'slide__link_hide': !slide.available.status}" :to="`/legends/${slide.id}`")
                                        span.slide__name( v-html="slide.name")
                                        span.slide__prof( v-html="`[${slide.profession.text}]`")
                                    button.slide__arrow.slide__arrow_next(@click="index < slides.length - 1 ? swiperInstance.slideNext() : swiperInstance.slideTo(0)")
                                        span(v-html="index < slides.length - 1 ? slides[index+1].name : slides[0].name")
                                Arrow.slide__stripe(type="stripe" :class="{'arrow_hidden': !slide.available.status}")

</template>

<script>
import {Swiper, HashNavigation, Navigation, Mousewheel, Keyboard, Pagination, EffectFade} from 'swiper/js/swiper.esm.js';
import {title, slides} from '@/assets/data/selector.json';
import {mapState} from 'vuex';

Swiper.use([HashNavigation, Mousewheel, Keyboard, Pagination, EffectFade, Navigation]);

export default {
    name: 'Legends',

    data() {
        return {
            title,
            slides,
            swiperInstance: null,
            pageId: this.$route.hash.replace('#', ''),
            scrollListener: false
        };
    },
    components: {
        Strap: () => import('@/components/Strap.vue'),
        Arrow: () => import('@/components/Arrow.vue'),
        Stars: () => import('@/components/Stars.vue')
    },
    watch: {
        $route(to) {
            this.pageId = to.hash.replace('#', '');
        }
    },
    computed: {
        ...mapState(['scrollListenerAvail'])
    },
    mounted() {
        this.swiperInstance = new Swiper(this.$refs.swiper, {
            keyboard: true,
            hashNavigation: {
                watchState: true,
                replaceState: false
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true
            },
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            }
        });

        this.swiperInstance.on('slideChange', () => {
            this.$refs.scroll.scrollTo(0, 0);
        });

        if (this.scrollListenerAvail) {
            this.scrollListener = true;
            this.$refs.scroll.addEventListener('scroll', this.routeScroll);
        }
        this.$store.watch(
            state => state.scrollListenerAvail,
            to => {
                if (!this.$refs.scroll) return;
                this.scrollListener = to;
                if (to) {
                    this.$refs.scroll.addEventListener('scroll', this.routeScroll);
                } else {
                    this.$refs.scroll.removeEventListener('scroll', this.routeScroll);
                }
            }
        );
    },
    beforeDestroy() {
        this.swiperInstance.destroy();
    },
    methods: {
        parallax(e, id) {
            const {clientX, clientY} = e;
            const {innerWidth, innerHeight} = window;
            let y = (-2 * clientY) / innerHeight + 1;
            let x = (-2 * clientX) / innerWidth + 1;
            const library = {
                plotkin: () => {
                    const plane = this.$refs.plotkinSlide[0].querySelector('.slide__decor-plotkin-plane-img');
                    const aim = this.$refs.plotkinSlide[0].querySelector('.slide__decor-plotkin-aim');
                    plane.style.transform = `translateY(${y * 5}%)`;
                    aim.style.transform = `rotate(${x * 70}deg)`;
                    const portrait = this.$refs.plotkinSlide[0].querySelector('.legend-header');
                    portrait.style.transform = `scale(${1 + x * 0.1})`;
                },
                sultan: () => {
                    const planes = this.$refs.sultanSlide[0].querySelectorAll('.js-sultan-plane');
                    const aims = this.$refs.sultanSlide[0].querySelectorAll('.slide__decor-sultan-aim');
                    planes.forEach(plane => {
                        plane.style.transform = `rotate(${(x + y) * 15}deg)`;
                    });
                    aims[0].style.transform = `translate(${(x + y) * 10}%, ${(x - y) * 10}%)`;
                    aims[1].style.transform = `translate(${(x + y) * -6}%, ${(x + y) * -6}%)`;
                    aims[2].style.transform = `translate(${(x + y) * 7.5}%, ${(x + y) * -7.5}%)`;
                    aims[3].style.transform = `translate(${(x - y) * -9}%, ${(x + y) * 9}%)`;
                    const portrait = this.$refs.sultanSlide[0].querySelector('.legend-header');
                    portrait.style.transform = `scale(${1 + x * 0.1})`;
                },
                german: () => {
                    const portrait = this.$refs.germanSlide[0].querySelector('.legend-header');
                    portrait.style.transform = `scale(${1 + x * 0.1})`;

                    const binokolus = this.$refs.germanSlide[0].querySelector('.slide__decor-german-binokolus');
                    binokolus.style.transform = `rotate(${(y + x) * 15}deg)`;
                },
                dachiev: () => {
                    const portrait = this.$refs.dachievSlide[0].querySelector('.legend-header');
                    const cavalry = this.$refs.dachievSlide[0].querySelector('.slide__decor-dachiev-cavalry');
                    const water = this.$refs.dachievSlide[0].querySelector('.slide__decor-dachiev-water');
                    cavalry.style.transform = `translate(${x + y}%, ${x - y}%)`;
                    water.style.transform = `translate(${(x - y) * -1}%, ${x + y}%)`;
                    portrait.style.transform = `scale(${1 + x * 0.1})`;
                },
                basanov: () => {
                    const portrait = this.$refs.basanovSlide[0].querySelector('.legend-header');
                    const cossacks = this.$refs.basanovSlide[0].querySelector('.slide__decor-basanov-cossacks');
                    const road = this.$refs.basanovSlide[0].querySelector('.slide__decor-basanov-road');

                    cossacks.style.transform = `translate(${(x - y) * -1}%, ${(x + y) * 1}%)`;
                    road.style.transform = `translate(${(x + y) * 1}%, ${(x - y) * 1}%)`;
                    portrait.style.transform = `scale(${1 + x * 0.1})`;
                },
                ohlopkov: () => {
                    const portrait = this.$refs.ohlopkovSlide[0].querySelector('.legend-header');
                    const gun = this.$refs.ohlopkovSlide[0].querySelector('.slide__decor-ohlopkov-gun');
                    const bullets = this.$refs.ohlopkovSlide[0].querySelector('.slide__decor-ohlopkov-bullets');
                    const forest = this.$refs.ohlopkovSlide[0].querySelector('.slide__decor-ohlopkov-forest');

                    gun.style.transform = `translate(${(x - y) * -1}%, ${(x + y) * 1}%)`;
                    bullets.style.transform = `translate(${(x - y) * -1}%, ${(x + y) * 1}%)`;
                    forest.style.transform = `translate(${(x + y) * 0.5}%, ${(x - y) * 1}%)`;
                    portrait.style.transform = `scale(${1 + x * 0.1})`;
                },
                domogakov: () => {
                    const portrait = this.$refs.domogakovSlide[0].querySelector('.legend-header');
                    const binoculars = this.$refs.domogakovSlide[0].querySelector('.slide__decor-domogakov-binoculars');
                    const map = this.$refs.domogakovSlide[0].querySelector('.slide__decor-domogakov-map');
                    const forest = this.$refs.domogakovSlide[0].querySelector('.slide__decor-domogakov-forest');

                    binoculars.style.transform = `translate(${(x - y) * 1.1}%, ${(x + y) * 1}%)`;
                    map.style.transform = `translate(${(x - y) * 0.3}%, ${(x + y) * 0.6}%)`;
                    forest.style.transform = `translate(${(x + y) * -0.5}%, ${(x - y) * 1}%)`;
                    portrait.style.transform = `scale(${1 + x * 0.1})`;
                }
            };
            if (!library[id]) return;
            library[id]();
        },
        routeScroll() {
            if (slides.find(item => item.id === this.pageId).available.status) {
                this.scrollListener = false;
                window.removeEventListener('scroll', this.routeScroll);
                this.$router.push(`/legends/${this.pageId}`, () => {});
            }
        }
    }
};
</script>

<style lang="scss">
@import '@/assets/css/legend-header.scss';

.slide {
    &__lock {
        text-align: center;

        svg {
            width: 40px;
            max-width: 40px;
            // width: min(10vw, 40px);
            margin-bottom: 10px;
        }
    }

    &__portrait {
        z-index: 2;
    }

    &__decor {
        &-star {
            position: absolute;
            top: 46%;
            left: 50%;
            width: calc(20 * var(--vh) + 20vw);
            max-width: 630px;
            transform: translate(-50%, -50%);

            &-img {
                opacity: 0.2;
            }
        }

        &-man {
            position: absolute;

            &_dachiev {
                width: 100%;
                top: 50%;
                left: 0;
                transform: translateY(-50%);
            }

            &_basanov {
                width: 85%;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }

            &_ohlopkov {
                width: 68%;
                top: 25%;
                left: 50%;
                transform: translateX(-50%);
            }

            &_domogakov {
                width: 65%;
                top: 1%;
                left: 50%;
                transform: translateX(-50%);
            }
        }

        &-plotkin {
            &-plane {
                position: absolute;
                top: 3%;
                left: 45.5%;
                width: calc(25vh + 25vw);
                width: calc(25 * var(--vh) + 25vw);
                height: auto;

                &-img {
                    transition: transform linear 0.1;
                }

                @media (--viewport-laptop) {
                    left: 60%;
                }
                @media (--viewport-mobile-l) {
                    width: 180%;
                    left: 10%;
                    top: 15%;
                }

                &-trajectory {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    background: url('../../assets/img/articles/plotkin/selector/selector-plotkin-plane-trajectory.png') center / contain no-repeat;
                }
            }

            &-aim-wrp {
                position: absolute;
                top: 42%;
                left: 37%;
                width: calc(10vh + 10vw);
                height: calc(10vh + 10vw);
                transform: translateX(-50%);
                transform-origin: 50% 50%;
            }

            &-aim {
                position: absolute;
                top: 0;
                left: 0;
                height: 100%;
                width: 100%;
                background: url('../../assets/img/articles/plotkin/selector/selector-plotkin-aim.svg') center / contain no-repeat;
            }
        }

        &-sultan {
            &-plane-path {
                position: absolute;
                top: 0;
                right: 25%;
                transform: translateX(50%) rotate(30deg);
                transform-origin: 50% 0;
                width: 35vw;
                max-width: 620px;
                min-width: 340px;
                @media (--viewport-laptop) {
                    right: 15%;
                }
                @media (--viewport-tablet) {
                    top: 34%;
                }
            }

            &-path {
                @media (--viewport-tablet) {
                    display: none;
                }
            }

            &-plane {
                position: absolute;
                bottom: 0;
                left: 0;
                width: 100%;
                transform-origin: 50% 5%;
                @media (--viewport-tablet) {
                    position: relative;
                }
            }

            &-plane-navigation {
                position: absolute;
                top: 55%;
                left: 20%;
                transform: rotate(-30deg);
                transform-origin: 0% 50%;
                max-width: 330px;
                width: 23vw;
                min-width: 160px;
                @media (--viewport-tablet) {
                    top: 40%;
                    left: -10%;
                }
            }

            &-navigation {
                @media (--viewport-tablet) {
                    opacity: 0.5;
                }
            }

            &-plane-nav {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                transform-origin: 45% 50%;
            }

            &-circles {
                position: absolute;
                top: 61%;
                left: 57%;
                transform: translate(-50%, -50%);
                max-width: 290px;
                min-width: 150px;
                width: 17vw;
                z-index: 0;
                @media (--viewport-tablet) {
                    opacity: 0.4;
                    left: 70%;
                    top: 64%;
                }

                &-plane {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;

                    &_small {
                        animation: plane-rotate 5s linear infinite reverse;
                        background: url('../../assets/img/articles/sultan/selector/sultan-selector-circles-plane-small.png') center / contain no-repeat;
                    }

                    &_big {
                        animation: plane-rotate 9s linear infinite;
                        background: url('../../assets/img/articles/sultan/selector/sultan-selector-circles-plane-big.png') center / contain no-repeat;
                    }
                }
            }

            &-aim {
                position: absolute;
                background: url('../../assets/img/articles/sultan/selector/sultan-selector-aim.png') center / contain no-repeat;
                width: 1.5rem;
                height: 1.5rem;
                @media (--viewport-tablet) {
                    width: 0.75rem;
                    height: 0.75rem;
                }

                &_path {
                    &-1 {
                        left: 35%;
                        bottom: 30%;
                        @media (--viewport-tablet) {
                            bottom: auto;
                            top: 10%;
                        }
                    }

                    &-2 {
                        left: 37%;
                        bottom: -10%;
                        opacity: 0.4;
                        @media (--viewport-tablet) {
                            left: 55%;
                        }
                    }
                }

                &_navigation {
                    &-1 {
                        left: 12%;
                        top: 0%;
                        @media (--viewport-tablet) {
                            display: none;
                        }
                    }

                    &-2 {
                        left: 12%;
                        bottom: -10%;
                        opacity: 0.8;
                        @media (--viewport-tablet) {
                            opacity: 1;
                            left: 49%;
                        }
                    }
                }
            }
        }

        &-german {
            &-trajectory {
                position: absolute;
                bottom: 0;
                left: 28%;
                max-width: 870px;
                width: 40%;
                height: auto;
                @media (--viewport-tablet) {
                    width: 93%;
                    left: -3%;
                    top: 28vh;
                }
            }

            &-mine {
                position: absolute;
                background: url('../../assets/img/articles/german/selector/german-selector-mine.png') center / contain no-repeat;

                &_1 {
                    width: 10%;
                    height: 10%;
                    top: 10%;
                    right: 15%;
                    animation: scaling 1.5s linear 0s infinite;
                    @media (--viewport-tablet) {
                        top: 4%;
                        right: 10%;
                    }
                }

                &_2 {
                    width: 7%;
                    height: 10%;
                    top: 28%;
                    left: 32%;
                    opacity: 0.7;
                    animation: scaling 1.5s linear -0.3s infinite;
                    @media (--viewport-tablet) {
                        top: 17%;
                        left: 35%;
                    }
                }

                &_3 {
                    width: 13%;
                    height: 13%;
                    top: 37%;
                    left: 20%;
                    opacity: 0.9;
                    animation: scaling 1.5s linear -0.9s infinite;
                    @media (--viewport-tablet) {
                        top: 23%;
                        left: 23%;
                    }
                }
            }

            &-binokolus-wrp {
                position: absolute;
                top: 55%;
                width: 20%;
                min-width: 112px;
                left: 50%;
                padding-top: 4.3%;
                background: url('../../assets/img/articles/german/selector/german-selector-scale.png') center top / 50% auto no-repeat;
                transform: translate(24%, -78%);
                @media (--viewport-tablet) {
                    top: 50%;
                    transform: translate(20%, -55%);
                    // top: 50%;
                    // right: 14%;
                    padding-top: 0;
                    background: none;
                }
            }
        }

        &-dachiev {
            &-cavalry {
                z-index: 2;
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: url('../../assets/img/articles/dachiev/selector/dachiev-selector-cavalry.png') 42% 80% / 45% auto no-repeat;
                @media (--viewport-tablet) {
                    opacity: 0.7;
                    left: -20%;
                    background-size: 100% auto;
                    background-position: 0% 80%;
                }
            }

            &-cavalry-arrows {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: url('../../assets/img/articles/dachiev/selector/dachiev-selector-cavalry-arrows.png') 42% 80% / 45% auto no-repeat;
                @media (--viewport-tablet) {
                    background-size: 90% auto;
                    background-position: 0% 68%;
                }
            }

            &-cavalry-cross {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: url('../../assets/img/articles/dachiev/selector/dachiev-selector-cavalry-cross.png') 42% 80% / 45% auto no-repeat;
                animation: scaling 2s linear 0s infinite;
                transform-origin: 25% 70%;
                @media (--viewport-tablet) {
                    left: 1%;
                    background-size: 100% auto;
                    background-position: 0% 68%;
                    transform-origin: 2.5% 68%;
                }
            }

            &-water {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: url('../../assets/img/articles/dachiev/selector/dachiev-selector-water.png') 74% 60% / 25% auto no-repeat;
                @media (--viewport-tablet) {
                    background-size: 75% auto;
                    background-position: 148% 65%;
                }
            }

            &-water-boat {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: url('../../assets/img/articles/dachiev/selector/dachiev-selector-water-boat.png') 74% 60% / 25% auto no-repeat;
                @media (--viewport-tablet) {
                    background-size: 55% auto;
                    background-position: 111% 53%;
                }
            }

            &-water-circle {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: url('../../assets/img/articles/dachiev/selector/dachiev-selector-water-circle.png') 74% 60% / 25% auto no-repeat;
                animation: scaling 2s linear 1s infinite;
                transform-origin: 78% 38.5%;
                @media (--viewport-tablet) {
                    background-size: 55% auto;
                    background-position: 100% 52.9%;
                    transform-origin: 98% 40.5%;
                }
            }
        }

        &-basanov {
            &-clouds {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                opacity: 0.5;
                background: url('../../assets/img/articles/basanov/selector/basanov-selector-clouds.png') 40% 60% / 50% auto no-repeat,
                    url('../../assets/img/articles/basanov/selector/basanov-selector-clouds-botom.png') 50% 90% / 90% auto no-repeat;
            }

            &-trajectory {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: url('../../assets/img/articles/basanov/selector/basanov-selector-trajectory.png') 31.5% 56% / 21% auto no-repeat;
                @media (--viewport-tablet) {
                    background: url('../../assets/img/articles/basanov/selector/basanov-selector-trajectory-mobile.png') 16% 50% / 30% auto no-repeat;
                }
            }

            &-tank {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;

                &_1 {
                    background: url('../../assets/img/articles/basanov/selector/basanov-selector-tank-1.png') 31.5% 56% / 21% auto no-repeat;
                }

                &_2 {
                    background: url('../../assets/img/articles/basanov/selector/basanov-selector-tank-2.png') 31.5% 56% / 21% auto no-repeat;
                }

                &_3 {
                    background: url('../../assets/img/articles/basanov/selector/basanov-selector-tank-3.png') 31.5% 56% / 21% auto no-repeat;
                }

                @media (--viewport-tablet) {
                    display: none;
                }
            }

            &-road {
                opacity: 0.8;
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: url('../../assets/img/articles/basanov/selector/basanov-selector-road.png') 42% 90% / 35% auto no-repeat;

                @media (--viewport-tablet) {
                    z-index: 3;
                    background-size: 50% auto;
                    background-position: 0% 90%;
                }

                @media (--viewport-mobile-l) {
                    background-size: 80% auto;
                    background-position: -30% 85%;
                }
            }

            &-cossacks {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: url('../../assets/img/articles/basanov/selector/basanov-selector-cossacks.png') 68% 83% / 30% auto no-repeat;

                @media (--viewport-tablet) {
                    z-index: 3;
                    background-size: 60% auto;
                    background-position: 100% 85%;
                }

                @media (--viewport-mobile-l) {
                    background-size: 80% auto;
                    background-position: 200% 85%;
                }
            }

            &-arrows {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: url('../../assets/img/articles/basanov/selector/basanov-selector-arrows.png') 63% 40% / 10.7% auto no-repeat;

                @media (--viewport-tablet) {
                    background: url('../../assets/img/articles/basanov/selector/basanov-selector-arrows-mobile.png') 88% 44% / 25% auto no-repeat;
                }
            }
        }

        &-ohlopkov {
            &-aim {
                position: absolute;
                top: calc(55vh);
                left: calc(28vw);
                width: calc(5vh + 6vw);
                height: calc(5vh + 6vw);

                background-image: url('../../assets/img/articles/ohlopkov/selector/ohlopkov-selector-aim.svg');
                background-size: contain;
                background-repeat: no-repeat;

                z-index: 5;
                animation: scaling 2.5s ease-in-out 0s infinite;

                @media (--viewport-tablet) {
                    top: calc(60vh);
                    left: calc(10vw);
                    width: calc(8vh + 6vw);
                    height: calc(8vh + 6vw);
                }
                @media (--viewport-mobile-l) {
                    background-image: url('../../assets/img/articles/ohlopkov/selector/ohlopkov-selector-aim-mob.png');
                    top: 66%;
                    left: 5%;
                    width: 18%;
                    height: 18%;
                }

                &-dark {
                    background: url('../../assets/img/articles/ohlopkov/selector/ohlopkov-selector-aim-dark.svg');
                    background-size: contain;
                    position: absolute;
                    width: calc(1vh + 3vw);
                    height: calc(1vh + 3vw);
                    top: calc(23vh);
                    left: calc(59vw);
                    z-index: 5;
                    animation: scaling 1.5s linear 1s infinite;
                    @media (--viewport-tablet) {
                        top: calc(28vh);
                        left: calc(57vw);
                    }
                    @media (--viewport-mobile-l) {
                        top: 32.5%;
                        left: 69%;
                        width: 8%;
                        height: 8%;
                        background-repeat: no-repeat;
                    }
                }
            }

            &-bullets {
                position: absolute;
                top: calc(34vh - 4.8vw);
                left: 68%;
                width: calc(10vh + 4.5vw);
                height: calc(10vh + 6.7vw);
                background-image: url('../../assets/img/articles/ohlopkov/selector/ohlopkov-selector-bullets.svg');
                background-repeat: no-repeat;
                background-size: contain;

                @media (--viewport-tablet) {
                    left: calc(68% + 3vw);
                    top: calc(34vh - 7vw);
                }

                @media (--viewport-mobile-l) {
                    background-image: url('../../assets/img/articles/ohlopkov/selector/ohlopkov-selector-bullets-mob.svg');
                    height: 9.5%;
                    width: 9%;
                    top: 36%;
                    left: 89.5%;
                }
            }

            &-gun {
                position: absolute;
                top: calc(25vh - 5vw);
                left: 63%;
                width: calc(30vh + 17vw);
                height: calc(30vh + 17vw);
                background-image: url('../../assets/img/articles/ohlopkov/selector/ohlopkov-selector-gun.png');
                background-repeat: no-repeat;
                background-size: contain;
                @media (--viewport-mobile-l) {
                    width: 20%;
                    height: 45%;
                    top: 31.5%;
                    left: 80%;
                }
            }
            &-bg {
                position: absolute;
                bottom: 0;
                width: 100%;
                height: 100%;
                background-size: auto 74%;
                background-position: 50% 100%;
                background-repeat: no-repeat;
            }
            &-forest {
                background-image: url('../../assets/img/articles/ohlopkov/selector/ohlopkov-selector-forest.png');
                background-size: 62% auto;
                background-position: 42% 91%;
                z-index: 3;
                @media (--viewport-tablet) {
                    background-size: 130% auto;
                }
                @media (--viewport-mobile-l) {
                    background-size: 170% auto;
                    background-position: 65% 92%;
                }
            }

            &-cloud {
                background-size: auto 100%;
                background-image: url('../../assets/img/articles/ohlopkov/selector/ohlopkov-selector-cloud.png');
            }
        }

        &-domogakov {
            &-mine {
                width: 2.7%;
                height: 2.7%;
                background-image: url('../../assets/img/articles/domogakov/selector/domogakov-selector-mine.png');
                background-size: contain;
                background-repeat: no-repeat;
                z-index: 6;

                @media (--viewport-tablet) {
                    width: 4%;
                    height: 4%;
                }
                @media (--viewport-mobile-l) {
                    width: 5%;
                    height: 5%;
                }

                &-1 {
                    position: absolute;
                    top: 27%;
                    left: 67%;
                    animation: scaling 1.5s ease-in-out 0s infinite;
                    @media (--viewport-tablet) {
                        top: 36%;
                        left: 71%;
                    }
                    @media (--viewport-mobile-l) {
                        top: 39%;
                        left: 71%;
                    }
                }
                &-2 {
                    position: absolute;
                    top: 41%;
                    left: 72%;
                    animation: scaling 2.5s ease-in-out 0s infinite;
                    @media (--viewport-tablet) {
                        top: 43.5%;
                        left: 76%;
                    }
                    @media (--viewport-mobile-l) {
                        //top: 47%;
                        top: calc(46vh + 1.5vw);
                        left: 80%;
                    }
                }
            }

            &-map {
                position: absolute;
                z-index: 2;
                top: 23%;
                left: 49%;
                width: 100%;
                height: 100%;
                max-height: 480px;
                background-image: url('../../assets/img/articles/domogakov/selector/domogakov-selector-map.png');
                background-repeat: no-repeat;
                background-size: 33%;
                @media (--viewport-desktop) {
                    top: 21%;
                }

                @media (--viewport-laptop-l) {
                    left: 48%;
                }
                @media (--viewport-tablet) {
                    top: 34%;
                    left: 48%;
                    background-size: 43%;
                }

                @media (--viewport-mobile-l) {
                    background-image: url('../../assets/img/articles/domogakov/selector/domogakov-selector-map-mob.png');
                    background-size: 65%;
                    top: 36%;
                    left: 34%;
                }
            }

            &-ruler {
                z-index: 2;
                position: absolute;
                top: 40%;
                left: 26%;
                width: 14%;
                height: 33%;
                background-image: url('../../assets/img/articles/domogakov/selector/domogakov-selector-ruler.png');
                background-repeat: no-repeat;
                background-size: contain;

                @media (--viewport-tablet) {
                    width: 16%;
                    left: 15%;
                    top: 30%;
                }

                @media (--viewport-mobile-l) {
                    visibility: hidden;
                }
            }
            &-binoculars {
                z-index: 2;
                position: absolute;
                top: 40%;
                left: 31%;
                width: 28%;
                height: 28%;
                background-image: url('../../assets/img/articles/domogakov/selector/domogakov-selector-binoculars.png');
                background-repeat: no-repeat;
                background-size: contain;
                @media (--viewport-laptop-l) {
                    width: 25%;
                    height: 25%;
                }
                @media (--viewport-tablet) {
                    width: 23%;
                    height: 23%;
                    left: 23%;
                    top: 45%;
                }
                @media (--viewport-mobile-l) {
                    width: 36%;
                    height: 36%;
                    left: 5%;
                    top: 44%;
                }
            }
            &-clouds-2 {
                z-index: 0;
                position: absolute;
                top: 19%;
                left: 20%;
                width: 100%;
                height: 100%;
                background-image: url('../../assets/img/articles/domogakov/selector/domogakov-selector-clouds-2.png');
                background-repeat: no-repeat;
                background-size: 35%;
                @media (--viewport-tablet) {
                    background-size: 42%;
                    top: 30%;
                }
                @media (--viewport-mobile-l) {
                    background-size: 67%;
                    left: 0;
                    top: 30%;
                }
            }
            &-forest {
                position: absolute;
                width: 100%;
                height: 100%;
                background-image: url('../../assets/img/articles/domogakov/selector/domogakov-selector-forest.png');
                background-size: 88% auto;
                background-position: 96% 114%;
                background-repeat: no-repeat;
                z-index: 3;
                @media (--viewport-desktop) {
                    background-position: 96% 138%;
                }
                @media (--viewport-laptop-l) {
                    background-position: 96% 108%;
                }
                @media (--viewport-tablet) {
                    background-size: 150% auto;
                    background-position: 30% 100%;
                }
                @media (--viewport-mobile-l) {
                    width: 126%;
                    background-position: 40% 84%;
                }
            }
            &-clouds {
                background-image: url('../../assets/img/articles/domogakov/selector/domogakov-selector-clouds.png');
                position: absolute;
                width: 110%;
                height: 110%;
                background-size: 110% auto;
                background-repeat: no-repeat;
                background-position: 30% 10%;
                @media (--viewport-tablet) {
                    background-size: 180% auto;
                    background-position: 30% 100%;
                }
                @media (--viewport-mobile-l) {
                    width: 130%;
                }
            }
        }
    }

    &__btns-wrp {
        position: absolute;
        bottom: 2vh;
        bottom: calc(2 * var(--vh));
        // bottom: 50px;
        width: 100%;
        font-size: 40px;
        z-index: 4;
        @media (--viewport-laptop-l) {
            font-size: calc((100vw - 320px) / (1925 - 320) * (40 - 20) + 20px);
        }
    }

    &__lead {
        // font-size: calc(1vh + 1.5vw);
        // font-size: 1.5rem;
        font-size: 1em;
        color: #fff;
        text-align: center;
        padding-bottom: 0.7em;

        @media (--viewport-tablet) {
            // font-size: 5vw;
            // font-size: 0.8rem;
            padding-left: calc(var(--padding-mobile));
            padding-right: calc(var(--padding-mobile));
        }
    }

    &__btns {
        line-height: 1.2;
        display: flex;
        align-items: center;
        justify-content: space-between;
        // font-size: calc(1vh + 1.5vw);
        font-size: 1em;
        width: 100%;
        box-sizing: border-box;
        color: var(--color-red);
        padding: 0.5em calc(var(--padding) * 2) 0;
        margin-bottom: 0.25em;
        position: relative;
        @media (--viewport-laptop-l) {
            padding-left: calc(var(--padding-mobile) * 2);
            padding-right: calc(var(--padding-mobile) * 2);
        }
        @media (--viewport-laptop) {
            // font-size: 5vw;
            justify-content: center;
            // margin-bottom: 0.25em;
        }
        // @media (--viewport-tablet) {
        //     margin-bottom: 0.25em;
        // }

        &::before {
            content: '';
            width: 4em;
            height: 2px;
            background-color: currentColor;
            position: absolute;
            top: 0;
            left: 50%;
            transform: translateX(-50%);
        }
    }

    &__link {
        color: var(--color-white-text);
        text-decoration: none;
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 1em;
        padding: 0 1em;

        &_hide {
            pointer-events: none;
        }
    }

    &__prof {
        font-size: 0.6em;

        @media (--viewport-laptop) {
            font-size: 1em;
        }
    }

    &__name {
        text-align: center;
    }

    &__arrow {
        // flex-grow: 1;
        font-size: 0.78em;
        min-width: 10%;
        position: relative;
        width: 11em;
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: inherit;
        transition: color 0.3s ease;

        &::before,
        &::after {
            transition: transform ease 0.2s;
            height: calc(1.5vh + 1.5vw);
            width: calc(1.5vh + 1.5vw);
            display: inline-block;
            background: url('../../assets/img/stripe.svg') center no-repeat;
        }

        &:hover {
            color: var(--color-red-light);
        }

        span {
            pointer-events: none;
        }

        @media (--viewport-laptop) {
            display: none;
        }

        &_next {
            text-align: left;

            &::after {
                content: '';
                transform: rotate(-90deg);
            }

            &:hover {
                &::after {
                    transform: rotate(-90deg) translateY(50%);
                }
            }
        }

        &_prev {
            text-align: right;

            &::before {
                content: '';
                transform: rotate(90deg);
            }

            &:hover {
                &::before {
                    transform: rotate(90deg) translateY(50%);
                }
            }
        }

        &_blocked {
            opacity: 0;
            pointer-events: none;
        }
    }

    &__stripe {
        margin: 0 auto;
        width: calc(1.5vh + 1.5vw);
        min-width: 20px;

        &.hidden {
            opacity: 0;
        }
    }
}

.selector {
    position: relative;
    top: 0;
    width: 100%;
    height: 100vh;
    height: calc(var(--vh) * 100);

    background: url('../../assets/img/selector-map.png') center / cover no-repeat,
        linear-gradient(136deg, rgb(23, 34, 17) 29%, rgb(64, 67, 45) 47%, rgb(105, 99, 73) 52%, rgb(69, 68, 48) 66%, rgb(33, 37, 22) 100%);

    &__wrp {
        height: 100vh;
        height: calc(var(--vh) * 100);
        overflow-y: scroll;
        max-width: var(--max-width);
        margin: 0 auto;
        position: relative;

        &-scroll {
            height: calc(100vh + 3px);
            height: calc(var(--vh) * 100 + 3px);
        }
    }

    &__decor-clouds {
        position: absolute;
        z-index: 0;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        background: url('../../assets/img/selector-clouds.png') center / cover no-repeat;
    }

    &.v-enter-to {
        position: fixed;
        z-index: 10;
    }

    &.v-leave-active {
        position: absolute;
        z-index: 10;
    }

    &__strap {
        // font-size: calc(2vh + 2vw);
        font-size: 1.7rem;
        position: absolute !important;
        z-index: 10;
        top: 17vh;
        top: calc(17 * var(--vh));
        left: var(--padding);
        // width: fit-content;
        @media (--viewport-laptop) {
            left: var(--padding-mobile);
        }
        @media (--viewport-tablet) {
            left: 0;
            font-size: 1.1rem;
        }
        @media (--viewport-mobile-l) {
            width: 100%;
            // font-size: 8vw;
        }
    }

    &__icon {
        opacity: 0.6;
        width: 6vw;
        height: 6vw;
        max-width: 48px;
        max-height: 48px;

        position: absolute;
        bottom: calc(var(--vh) * 5);
        left: 40px;
        z-index: 1;

        @media (--viewport-tablet) {
            max-height: 38px;
            max-width: 38px;

            bottom: calc(var(--vh) * 4);
            left: 40px;
        }
        @media (--viewport-mobile-l) {
            max-height: 35px;
            max-width: 35px;

            left: 1em;
            bottom: 1.4em;
        }
    }
}

.swiper {
    &-container,
    &-wrapper,
    &-slide {
        min-height: calc(var(--vh) * 100);
        transition-timing-function: ease;
    }

    &-nav {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: none;
        pointer-events: none;
        z-index: 17;

        @media (--viewport-laptop) {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            padding: var(--padding-mobile);
        }

        &__prev {
            pointer-events: all;

            &::before {
                content: '';
                display: inline-block;
                height: calc(2.5vh + 4.5vw);
                max-width: 25px;
                max-height: 25px;
                width: calc(2.5vh + 4.5vw);
                background: url('../../assets/img/stripe.svg') center no-repeat;
                transform: rotate(90deg);
            }
        }

        &__next {
            pointer-events: all;

            &::before {
                content: '';
                display: inline-block;
                height: calc(2.5vh + 4.5vw);
                width: calc(2.5vh + 4.5vw);
                max-width: 25px;
                max-height: 25px;
                background: url('../../assets/img/stripe.svg') center no-repeat;
                transform: rotate(-90deg);
            }
        }
    }

    &-slide {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    &-pagination {
        position: fixed;
        top: 66px !important;
        bottom: auto !important;
        left: 0;

        @media (--viewport-laptop) {
            top: 65vh !important;
            top: calc(65 * var(--vh)) !important;
        }

        &-bullet {
            max-height: 26px;
            max-width: 27px;
            height: 5vw;
            width: 5vw;
            border-radius: 0;
            background: url('../../assets/img/star-empty.svg') center / contain no-repeat;
            opacity: 1;
            margin: 0 12px !important;
            transition: all 0.2s ease;

            &-active {
                background: url('../../assets/img/star.svg') center / contain no-repeat;
            }

            &:hover {
                background: url('../../assets/img/star.svg') center / contain no-repeat;
                transition: all 0.4s ease;
            }
        }
    }
}

@keyframes plane-rotate {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

@keyframes scaling {
    0% {
        transform: scale(1);
    }
    50% {
        transform: scale(0.9);
    }
    100% {
        transform: scale(1);
    }
}

.mob-hidden {
    @media (--viewport-mobile-l) {
        visibility: hidden;
    }
}
</style>
